import React, { useCallback, useContext, useEffect, useState } from 'react'
import { StepCellStyles, StepStyles } from './Style'
import { Tooltip } from '@mui/material'
import { AssessmentsContext, batteryViewTypes } from './AssessmentsContext'
import { Chip } from 'components/Form'
import { categoriesWithIcons } from 'keys/categories'
import { ratingListChipColors } from 'keys/rating'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

const PerformBatteryCell = (props) => {
    const { cell, row } = props
    const { battery_performance } = row.original

    const [viewCell, setViewCell] = useState(batteryViewTypes.circle)

    const { performBatteryCellView } = useContext(AssessmentsContext)

    useEffect(() => {
        setViewCell(performBatteryCellView)
    }, [performBatteryCellView])

    const updateViewCell = useCallback(() => {
        if (viewCell == batteryViewTypes.circle)
            setViewCell(batteryViewTypes.details)
        else
            setViewCell(batteryViewTypes.circle)
    }, [viewCell])

    const Icon = viewCell == batteryViewTypes.circle ? ChevronLeft : ChevronRight

    return (
        <StepCellStyles>
            <div className='assessment-items'>
                {battery_performance?.map((item) => {
                    let chipColor = ratingListChipColors[item.index - 1]
                    if (item.index == 0)
                        chipColor = "gray"
                    else if (!chipColor)
                        chipColor = "gray4"

                    return (
                        viewCell == batteryViewTypes.circle ?
                            <Tooltip title={item.assessment_category_label}>
                                <StepStyles index={item.index}>
                                    <div className={`circle-item`} />
                                </StepStyles>
                            </Tooltip>
                            :
                            <Chip color={chipColor}>
                                {categoriesWithIcons[item.assessment_category_name].label}
                            </Chip>
                    )
                })}
                <div className='wrap-expand-icon' onClick={updateViewCell}>
                    <Icon className='expand-btn' />
                </div>
            </div>

        </StepCellStyles>
    )
}

export default PerformBatteryCell